import OtherToolsIcon from './other-tools-icon';
export default OtherToolsIcon;
